
import { User } from "@/models/user";
import { MetricService } from "@/services/metric-service";
import { ActiveUser } from "@/utils/active-user";
import { ActiveUserSessionInfo } from "@/utils/active-user-session-info";
import { ActiveUsersList } from "@/utils/active-users-list";
import Vue from "vue";
import AppActiveUserListSessionInfo from "./ActiveUserListSessionInfo.vue";

export default Vue.extend({
	data(){
		return {
			list: null as null | ActiveUsersList,
			openedSessionInfoUser: null as null | ActiveUser,
			openedSessionInfo: [] as ActiveUserSessionInfo[]
		};
	},
	methods: {
		openUserCompany(user:User){
			console.log(user);
			this.$router.push(`/companies/${user.companyId}/edit`);
		},
		onScroll(event:Event){
			let target = event.target as HTMLElement;
			if (target.offsetTop > target.scrollHeight - target.clientHeight) {
				console.log("Should Fetch");
			}
		},
		async getSessionInfo(user:ActiveUser){
			this.openedSessionInfo = await MetricService.getActiveUserSessionInfo(user.id);
			this.openedSessionInfoUser = user;
		},
		closeSessionInfo(){
			this.openedSessionInfoUser = null;
			this.openedSessionInfo = [];
		}
	},
	async created(){
		this.list = await MetricService.getActiveUsers(1000, 1);
	},
	destroyed(){
		if (!this.list) return;
		this.list.destroy();
	},
	components: {
		AppActiveUserListSessionInfo
	}
});
